window.GoodMorningToolEngineAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['GoodMorningToolEngine']);

    self.testConnection = async (brandId, hostname, port, path, username, password, channel) => {
        const url = `brands/${brandId}/export_scheduler_config/test_connection`;
        const payload = {
            channel_type: channel,
            metadata: JSON.stringify({
                hostname,
                port,
                path,
                username,
                password
            })
        };

        const response = await _protected.request(url, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.createScheduleExport = async (brandId, payload) => {
        const url = `brands/${brandId}/export_scheduler_config`;
        const response = await _protected.request(url, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getScheduleExports = async (brandId, page, size, searchTerm = '', sort, sortType) => {
        const url = `brands/${brandId}/export_scheduler_config`;
        const params = {
            page: page,
            size: size,
            sort: sort,
            sort_order_type: sortType
        };

        if (searchTerm) {
            params.search = searchTerm;
        }

        if (searchTerm) {
            params.export_name = searchTerm;
        }

        const response = await _protected.request(url, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.deleteScheduleExport = async (brandId, scheduleId) => {
        const url = `brands/${brandId}/export_scheduler_config/${scheduleId}`;
        const response = await _protected.request(url, 'DELETE');

        if (response?.status !== 200) {
            throw response;
        }
    };

    self.getScheduleExport = async (brandId, scheduleId) => {
        const url = `brands/${brandId}/export_scheduler_config/${scheduleId}`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateScheduleExport = async (brandId, payload, scheduleId) => {
        const url = `brands/${brandId}/export_scheduler_config/${scheduleId}`;
        const response = await _protected.request(url, 'PUT', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };
};
